import * as React from 'react';
import { Button as MuiButton } from '@mui/material';
import { ButtonProps as MuiButtonProps } from '@mui/material/Button';

import { buttonVariantStyles, commonStyles, largerText } from './buttonCssDefs';

export type ButtonColor = 'danger' | 'primary' | 'secondary' | 'success';
export interface ButtonProps extends Pick<MuiButtonProps, Exclude<keyof MuiButtonProps, 'color'>> {
  color?: ButtonColor;
  component?: React.ElementType;
  to?: string;
  target?: string;
  rel?: string;
  /**
   * When rendering an Anchor component with an external link
   * this value will be sent to google analytics
   */
  trackingCategory?: string;
}

/**
 * Use `Button` to place a button on the ui
 *
 * ```js
 * import { Button } from 'ui';
 * ```
 *
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
const Button = React.forwardRef<HTMLButtonElement, React.PropsWithChildren<ButtonProps>>(
  ({ color = 'primary', variant = 'contained', children, size = 'medium', ...rest }, ref) => {
    return (
      <MuiButton
        ref={ref}
        css={[commonStyles(color), buttonVariantStyles[variant], size !== 'small' && largerText]}
        size={size}
        variant={variant}
        {...rest}
      >
        {children}
      </MuiButton>
    );
  }
);

export default Button;
